var _rect, _rect2, _g, _rect3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimelineDrag = function SvgTimelineDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.84375,
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3260_14097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 20,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 22 6.84375)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3260_14097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 16.8438L14.0625 12.9062L13 11.8438L8 16.8438L13 21.8438L14.0625 20.7812L10.125 16.8438Z",
    fill: "#202124"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3260_14097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 20,
    height: 21
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.84375,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3260_14097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 16.8438L17.9375 12.9062L19 11.8438L24 16.8438L19 21.8438L17.9375 20.7812L21.875 16.8438Z",
    fill: "#202124"
  }))));
};
export default SvgTimelineDrag;